import { AfterViewInit, ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { dateFormat, SearchFields, SearchItems } from '../../core';
import { ListService } from '../../services';
import { BaseComponent, ConvertDatePipe, ReplaceLongLegPipe } from '../../shared';
import { PaginationComponent } from '../pagination';
import { ReceivedActionComponent } from '../received-action';
import { SortableHeaderComponent, SortEvent } from '../sortable-header';


/**
* Received plans table component.
*/
@Component({
	selector: 'received-table',
	templateUrl: './received-table.component.html',
	imports: [
		ConvertDatePipe,
		ReplaceLongLegPipe,
		PaginationComponent,
		ReceivedActionComponent,
		SortableHeaderComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ReceivedTableComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {

	private readonly listSrv = inject(ListService);

	collectionSize: number = 0;
	receivedList: SearchItems[] = [];

	@ViewChildren(SortableHeaderComponent) headers = new QueryList<SortableHeaderComponent>();
	activeColumn: string | null = null;

	readonly fields = SearchFields;
	readonly dateFormat = dateFormat();
	private _searchResultSub$?: Subscription;


	ngOnInit(): void {
		this.listSrv.resetSearchResult();
		this.listSrv.resetReceivedSearch();
		this._searchResultSub$ = this.listSrv.getSearchResult().subscribe(list => {
			this.collectionSize = list ? list.count : 0;
			this.receivedList = list ? list.items : [];
		});
	}

	ngAfterViewInit(): void {
		setTimeout(() => this.updateSortHeaders());
	}
	private updateSortHeaders(): void {
		const sortOrder = this.listSrv.getSortOrder();
		if (sortOrder) {
			this.headers.find(header => header.name() == sortOrder.name)?.direction.set(sortOrder.desc ? 'desc' : 'asc');
			this.activeColumn = sortOrder.name;
		}
	}

	/**
	* Update column sort order and sort list.
	*/
	onSort({ column, direction }: SortEvent): void {
		// resetting other headers
		for (const header of this.headers.filter(h => h.name() !== column)) {
			header.reset();
		}
		// sorting
		if (direction === '') {
			direction = column === this.listSrv.PLAN_DEFAULT_SORT.name || !this.listSrv.PLAN_DEFAULT_SORT.desc ? 'asc' : 'desc';
			column = this.listSrv.PLAN_DEFAULT_SORT.name;
		}
		this.listSrv.sort(column, direction);
		this.updateSortHeaders();
	}


	ngOnDestroy(): void {
		this._searchResultSub$?.unsubscribe();
		this.listSrv.resetSearchResult();
	}

}
